import metadata from 'libphonenumber-js/min/metadata';

import type { PhoneNumber as LibPhoneNumber } from 'libphonenumber-js/core';

import {
    parsePhoneNumber as _parsePhoneNumber,
    isPossiblePhoneNumber as _isPossiblePhoneNumber,
} from 'libphonenumber-js/core';

export type PhoneNumber = {
    countryCode: string;
    number: string;
};

export const isPossiblePhoneNumber = (value: string): boolean => {
    return _isPossiblePhoneNumber(value, metadata);
};

export const parsePhoneNumber = (value: string): LibPhoneNumber => {
    return _parsePhoneNumber(value, metadata);
};

export const formatPhoneNumberInternational = (phoneNumber: string): string => {
    return parsePhoneNumber(phoneNumber).formatInternational();
};

export const composePhoneNumber = (phone: PhoneNumber) => {
    if (phone.number.startsWith('+')) {
        // If the number already includes the country code, return it as is
        return phone.number;
    }

    return `${phone.countryCode}${phone.number}`;
};

export const normalizeCountryCode = (code: string) => {
    return code.startsWith('+') ? code : '+' + code;
};

export const parsePhone = (
    phoneString?: string | null,
): PhoneNumber | undefined => {
    if (!phoneString || phoneString === '') return undefined;

    let parsedPhone = null;
    let phoneCountryCode = null;
    let phoneNumber = null;
    if (phoneString) {
        parsedPhone = parsePhoneNumber(phoneString);
        phoneCountryCode = parsedPhone?.countryCallingCode
            ? normalizeCountryCode(parsedPhone.countryCallingCode)
            : null;
        phoneNumber = parsedPhone?.nationalNumber;
    }
    if (!phoneNumber || !phoneCountryCode) return undefined;

    return {
        number: phoneNumber as string,
        countryCode: phoneCountryCode,
    };
};
